import { Field } from '../../../types';

export interface Step {
    title: string
    steps: InnerStep[]
}
export interface Label {
    text: string;
    type: string;
}
export interface InnerStep {
    title: string
    theme: string
    type: string
    action?: string
    fields: (Field|Label)[]
    from?: string
    to?: string
    addAfter?: string[]
    addAt?: any
}
const steps: Step[] = [
  {
    title: 'Step 1',
    steps: [
      {
        title: 'Your Details',
        theme: 'light',
        type: 'form',
        fields: [
          {
            type: 'h3',
            text: 'Build your quote in 3 minutes.',
          },
          {
            type: 'p',
            text: 'First, let’s start with a few details about you.',
          },

        ],
        from: 'ptc',
        to: 'policy-start-date-heading-row',
        addAfter: ['privacy_policy_notice'],
      },
      {
        title: 'Policy Start Date',
        theme: 'light',
        type: 'form',
        fields: [

          {
            type: 'h3',
            text: 'Nice to meet you, {quote_forename}.',
            label: '',
            id: '',
            formId: '',
          },
          {
            type: 'p',
            text: 'When would you like your policy to start?',
            label: '',
            id: '',
            formId: '',
          },
        ],
        from: 'more_inception',
        to: 'more_inception',
      },
      {
        title: 'Your Business',
        theme: 'light',
        type: 'form',
        fields: [
          {
            type: 'h3',
            text: 'No problem we can get that sorted.',
            label: '',
            id: '',
            formId: '',
          },
          {
            type: 'p',
            text: 'Let’s talk a bit more about your business',
            label: '',
            id: '',
            formId: '',
          },
        ],
        from: 'quote_prop_74',
        to: 'quote_prop_96',
      },
      {
        title: 'Tailor your package',
        theme: 'light',
        type: 'form',
        fields: [

        ],
        from: 'quote_prop_57',
        to: 'form-your_quote',
        action: 'quote',
        addAfter: ['form-included-as-standard'],
      },
    ],
  },
  {
    title: 'Step 2',
    steps: [
      {
        title: 'Your Quote',
        theme: 'dark',
        type: 'review',
        action: 'important',
        fields: [

        ],
        from: '',
        to: '',
      },
      {
        title: 'Important Bits',
        theme: 'light',
        type: 'form',
        action: 'about',
        fields: [
          {
            type: 'h3',
            text: 'Just a few important bits to run over.',
            label: '',
            formId: 'important-title',
            id: 'important-title',
            style: 'important-title',
            data: 'important-title',
            'group-name': '',
          },
          {
            type: 'p',
            text: 'We’ll just need some additional details.',
            label: '',
            id: '',
            formId: '',
          },
        ],
        from: 'more_referral_60',
        to: 'more_submit',
      },
    ],
  },
  {
    title: 'Step 3',
    steps: [
      {
        title: 'Contact Details',
        theme: 'light',
        type: 'form',
        fields: [

        ],
        from: 'you_title',
        to: 'you_submit',
        action: 'payment',
      },
    ],
  },
  {
    title: 'Step 4',
    steps: [
      {
        title: 'Review',
        theme: 'dark',
        type: 'review',
        from: '',
        to: '',
        fields: [],
      },
      {
        title: 'Payment Quote',
        theme: 'light',
        type: 'form',
        action: 'process',
        from: 'ptc',
        to: 'payment_paytype',
        addAfter: ['payment_breakdown', 'automatic_renewals', 'direct_debit_terms', 'coupon_message'],
        fields: [
          {
            type: 'h3',
            text: 'You’re all set!',
            label: '',
            id: '',
            formId: '',
          },
          {
            type: 'p',
            text: 'Please make sure you’re happy with everything before you make your payment.',
            label: '',
            id: '',
            formId: '',
          },
          {
            type: 'p',
            text: 'Payment choice',
            label: '',
            id: '',
            formId: '',
          },
        ],
      },
      {
        title: 'Complete',
        theme: 'light',
        type: 'form',
        from: 'main_content',
        to: 'main_content',
        fields: [],
      },
    ],
  },
];
export default steps;
